import { t } from 'ttag'

import { api } from '@h2/api'

const augmentSchools = schools =>
  schools.map(school => ({
    ...school,
    /**
     * Add properties needed by certain API endpoints.
     * For instance, POST /personalProfile/{userId}
     * @see http://app.headed2:8080/api/v2/redoc/#operation/postPersonalprofileUserid
     */
    id: school.id ?? school.value ?? '',
    kind: school.kind ?? school.type ?? '',
    name: school.name ?? school.label,
    // Add properties expected by AutoSuggest or Selects
    value: school.value ?? school.id,
    label: school.label ?? school.name
  }))
const loadSchools = async (query, state) => {
  const opts = {
    method: 'POST',
    version: 'v1',
    body: state ? JSON.stringify({ restrictToState: state }) : undefined
  }
  const schools = await api.fetch(
    `/search/suggest/schools/${encodeURIComponent(query)}`,
    {
      ...opts,
      version: 'v1'
    }
  )

  return augmentSchools(schools)
}
const renderSchool = ({ label, address, city, state }) => {
  if (!address && !city && !state) {
    return <strong>{label}</strong>
  }

  return (
    <dl>
      <dt>{label}</dt>
      {address && <dd>{address}</dd>}
      {city && state && (
        <dd>
          {city}, {state}
        </dd>
      )}
    </dl>
  )
}
/**
 * Builds items (options) that can be used to populate an AutoSuggest or Select component.
 *
 * @param {number} seniorYear The seniorYear configured for a site
 * @param {number} isNavianceElementary The boolean value configured for a site denoting whether the site is Naviance Elementary
 * @returns {array} Graduation years based on the provided seniorYear
 */
const getFutureGraduationItems = (seniorYear = 0, isNavianceElementary = false) => {
  if (seniorYear && !isNavianceElementary) {
    return [
      t`Senior`,
      t`Junior`,
      t`Sophomore`,
      t`Freshman`,
      t`8th Grade`,
      t`7th Grade`,
      t`6th Grade`,
      t`5th Grade`,
      t`4th Grade`,
      t`3rd Grade`,
      t`2nd Grade`,
      t`1st Grade`,
      t`Kindergarten`
    ].map((name, idx) => ({
      label: `${seniorYear + idx} (${name})`,
      value: seniorYear + idx
    }))
  }

  if (seniorYear && isNavianceElementary) {
    const fifthGradeYear = seniorYear + 7

    return [
      t`5th Grade`,
      t`4th Grade`,
      t`3rd Grade`,
      t`2nd Grade`,
      t`1st Grade`,
      t`Kindergarten`
    ].map((name, idx) => ({
      label: `${fifthGradeYear + idx} (${name})`,
      value: fifthGradeYear + idx
    }))
  }

  return []
}

export { augmentSchools, loadSchools, renderSchool, getFutureGraduationItems }
